var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useAddPermissions, usePermittedActionsList, useRemovePermissions } from '@data/permission/permissionActions';
import { apiKeysApi, usersApi } from '@data/rest/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMutationOptionsFactory } from '../../util/query';
import { selectActionsByEntityId } from '../permission/permission';
export var userKeys = Object.freeze({
    all: ['users'],
    lists: function () {
        return __spreadArray(__spreadArray([], __read(userKeys.all), false), ['lists'], false);
    },
    list: function (filter) {
        return (filter ? __spreadArray(__spreadArray([], __read(userKeys.lists()), false), [filter], false) : __spreadArray([], __read(userKeys.lists()), false));
    },
    details: function () {
        return __spreadArray(__spreadArray([], __read(userKeys.all), false), ['details'], false);
    },
    detail: function (id) {
        return __spreadArray(__spreadArray([], __read(userKeys.details()), false), [id], false);
    },
    actions: function () {
        return __spreadArray(__spreadArray([], __read(userKeys.all), false), ['actions'], false);
    },
    permissions: function () {
        return __spreadArray(__spreadArray([], __read(userKeys.lists()), false), ['permissions'], false);
    },
    permission: function (id, filter) {
        return __spreadArray(__spreadArray([], __read(userKeys.permissions()), false), [id, filter], false);
    },
});
var mutationOptionsFactory = getMutationOptionsFactory();
export function getUsers(context) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, filter;
        return __generator(this, function (_b) {
            _a = __read(context.queryKey, 3), filter = _a[2];
            return [2 /*return*/, usersApi.list(filter)];
        });
    });
}
export function useUsers(options) {
    var key = userKeys.list(options === null || options === void 0 ? void 0 : options.filter);
    return useQuery(key, getUsers, options);
}
export function getAssignedPermissions(context) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, userId, filter;
        return __generator(this, function (_b) {
            _a = __read(context.queryKey, 5), userId = _a[3], filter = _a[4];
            if (!userId) {
                throw new Error('User ID was not specified');
            }
            return [2 /*return*/, usersApi.getPermissions(userId, filter)];
        });
    });
}
export function useUserAssignedPermissions(userId, filter, options) {
    var key = userKeys.permission(userId, filter);
    return useQuery(key, getAssignedPermissions, __assign(__assign({}, options), { enabled: !!userId }));
}
function getUser(context) {
    return __awaiter(this, void 0, Promise, function () {
        var _a, id;
        return __generator(this, function (_b) {
            _a = __read(context.queryKey, 3), id = _a[2];
            if (!id) {
                throw new Error('User ID was not specified');
            }
            return [2 /*return*/, usersApi.get(id)];
        });
    });
}
export function useUser(id, options) {
    var queryClient = useQueryClient();
    var key = userKeys.detail(id);
    var roleQuery = useQuery(key, getUser, __assign(__assign({}, options), { enabled: !!id && (options === null || options === void 0 ? void 0 : options.enabled), initialData: function () {
            var allUsers = queryClient.getQueryData(userKeys.list());
            var targetUser = allUsers === null || allUsers === void 0 ? void 0 : allUsers.find(function (r) { return r.id === id; });
            if (targetUser) {
                return targetUser;
            }
        } }));
    return roleQuery;
}
function getUserActions() {
    return usersApi.actions();
}
export function useActionsByUserId(options) {
    return usePermittedActionsList(userKeys.actions(), getUserActions, __assign(__assign({}, options), { select: selectActionsByEntityId }));
}
function createUser(command) {
    return usersApi.create(command);
}
export function useCreateUser() {
    var queryKey = userKeys.list();
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('create', queryKey, queryClient, [userKeys.actions()]);
    return useMutation(createUser, options);
}
function createServiceUser(command) {
    return __awaiter(this, void 0, void 0, function () {
        var serviceUser;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, usersApi.create(command)];
                case 1:
                    serviceUser = _a.sent();
                    return [2 /*return*/, apiKeysApi.create({ serviceUserId: serviceUser.id })];
            }
        });
    });
}
export function useCreateServiceUser() {
    var queryKey = userKeys.list();
    var queryClient = useQueryClient();
    return useMutation(createServiceUser, {
        onSettled: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(queryKey)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
    });
}
function removeUser(id) {
    return usersApi.remove(id);
}
export function useRemoveUser() {
    var queryKey = userKeys.list();
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('delete', queryKey, queryClient);
    return useMutation(removeUser, options);
}
function addUserPermission(command) {
    var id = command.id, permissions = command.permissions;
    return usersApi.addPermissions(id, { permissions: permissions });
}
export function useAddUserPermissions(filter) {
    return useAddPermissions(addUserPermission, userKeys, filter);
}
function removeUserPermission(command) {
    var id = command.id, permissions = command.permissions;
    return usersApi.removePermissions(id, { permissions: permissions });
}
export function useRemoveUserPermissions(filter) {
    return useRemovePermissions(removeUserPermission, userKeys, filter);
}
